import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=3b16c40a&scoped=true"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=3b16c40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16c40a",
  null
  
)

export default component.exports